export default __webpack_public_path__ + "static/media/email-icon.f967efef.svg";